import React from 'react';
import { Link } from 'react-router-dom';
import './css/index.scss';
import onClickOutside from 'react-onclickoutside';
import _ from 'lodash';

class profileMenuUnlogged extends React.Component {
    handleClickOutside = evt => {
        if(this.props.profileMenuClicked)
            this.props.profileMenuClick(evt);
    };

  render() {
      return (
      <div className="profile-menu">
        <div className="profile-menu-item">
          <Link onClick={this.props.profileMenuClick} to="/sign-up">
            <div className="menu-icon general-settings-icon" />
            <div className="profile-menu-item-label">{_.get(this.props.trans, 'signup', 'Sign up')}</div>
          </Link>
          <div className="clear" />
        </div>
        <div className="profile-menu-item">
          <Link onClick={this.props.profileMenuClick} to="/login">
            <div className="menu-icon profile-icon" />
            <div className="profile-menu-item-label">{_.get(this.props.trans, 'login', 'Login')}</div>
          </Link>
          <div className="clear" />
        </div>
      </div>
    );
  }
}

export default onClickOutside(profileMenuUnlogged);
